var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongZhankaiShang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 8.175a.5.5 0 01-.38.825H6.087a.5.5 0 01-.38-.825L7.62 5.943a.5.5 0 01.76 0l1.912 2.232z",
    fill: "#3F465C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjI5MjUgOC4xNzQ2QzEwLjU3MDUgOC40OTg5NCAxMC4zNDAxIDkgOS45MTI4OSA5SDYuMDg3MTFDNS42NTk5MyA5IDUuNDI5NDggOC40OTg5NCA1LjcwNzQ4IDguMTc0Nkw3LjYyMDM3IDUuOTQyOUM3LjgxOTkyIDUuNzEwMDkgOC4xODAwOCA1LjcxMDA5IDguMzc5NjMgNS45NDI5TDEwLjI5MjUgOC4xNzQ2WiIgZmlsbD0iIzNGNDY1QyIvPgo8L3N2Zz4K";
export { SvgTongyongZhankaiShang as ReactComponent };